import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./App.css";
import "./Loading.css";
import "./components/Investment.css";
import Loading from "./Loading.js";
import Util from "./util.js";
import store from "./ReduxStore.js";
import { Provider } from "react-redux";
import { Router, Route, hashHistory } from "react-router";
import Investment from "./components/Investment";
import Transfer from "./components/Transfer";
import BindingMobile from "./components/sync/BindingMobile";
import QuestionnaireList from "./components/pubQuestion/QuestionnaireList";
import FinishQuestionnaireSuccess from "./components/pubQuestion/FinishQuestionnaireSuccess";
import HighestRiskPoint from "./components/pubQuestion/HighestRiskPoint";
import AddCard from "./components/AddCard";
import AddPhone from "./components/AddPhone";
import Verification from "./components/Verification";
import Recommend from "./components/recommend/Recommend.js";
import KnowMore from "./components/recommend/KnowMore.js";
import Encyclopedia from "./components/recommend/Encyclopedia.js";
import EncyclopediaDetail from "./components/recommend/EncyclopediaDetail.js";
import RecoQuestionDoing from "./components/recommend/RecoQuestionDoing.js";
import RecoQuestionFinish from "./components/recommend/RecoQuestionFinish.js";
import PensionCalculator from "./components/recommend/PensionCalculator.js";
import PensionCalculatorResult from "./components/recommend/PensionCalculatorResult.js";
import PensionCalculatorPlan from "./components/recommend/PensionCalculatorPlan.js";
import EducationCalculatorSelectSchool from "./components/recommend/EducationCalculatorSelectSchool.js";
import EducationCalculator from "./components/recommend/EducationCalculator.js";
import EducationCalculatorResult from "./components/recommend/EducationCalculatorResult.js";
import EducationCalculatorPlan from "./components/recommend/EducationCalculatorPlan.js";
import CertificationCard from './components/recommend/CertificationCard.js';
import CertificationUpload from './components/recommend/CertificationUpload.js';
import CertiUpload from './components/recommend/CertiUpload.js';
import ChangTime from './components/recommend/ChangTime.js';
import CertificationCardAgain from './components/recommend/CertificationCardAgain.js';
import CertificationSetPhone from './components/recommend/CertificationSetPhone.js';
import CertificationCheckPhone from './components/recommend/CertificationCheckPhone.js';
import CertificationSetPassWord from './components/recommend/CertificationSetPassWord.js';
import PaymentSuperFund from "./components/PaymentSuperFund";
import PaymentAllSuperFund from "./components/PaymentAllSuperFund";
import FixedInvestmentSuperFund from "./components/myAssets/payment/FixedInvestmentSuperFund.js";
import FixedInvestmentSuperFundChange from "./components/myAssets/payment/FixedInvestmentSuperFundChange.js";
import RedeemSuperFund from "./components/RedeemSuperFund";
import RedeemCurrencyList from "./components/RedeemCurrencyList";
import RedeemBankList from "./components/RedeemBankList";
import Success from "./components/Success";
import ErrorResult from "./components/Error";
import PayCardList from "./components/myAssets/payment/PayCardList";
import HqtCardList from "./components/myAssets/payment/HqtCardList";
import WebView from "./components/WebView";
import SuperFundList from "./components/fundDetail/SuperFundList";
import TransactionRecord from "./components/fundDetail/TransactionRecord";
import OperationRecord from "./components/fundDetail/OperationRecord";
import Configuration from "./components/fundDetail/Configuration";
import TaxInfo from "./components/fundDetail/TaxInfo";
import TransactionDetail from "./components/fundDetail/TransactionDetail";
import Login from "./components/Login";
import Loginkah from './components/Loginkah';
import LoginHxcf from "./components/LoginHxcf";
import UserBindingMobile from "./components/login/UserBindingMobile";
import HxjjBindingMobile from "./components/login/HxjjBindingMobile";
import Register from "./components/login/Register";
import ForgetPassword from "./components/login/ForgetPassword";
import VerifyDynamicCode from "./components/login/VerifyDynamicCode";
import VerifyDynamicCodeSec from "./components/login/VerifyDynamicCodeSec";
import SetNewPassword from "./components/login/SetNewPassword";
import TransitRecords from "./components/fundDetail/TransitRecords";
import TransitHistory from "./components/fundDetail/TransitHistory";
import TransitHistoryDetial from "./components/fundDetail/TransitHistoryDetial";
import TaxSuccess from "./components/fundDetail/TaxSuccess";
import NullView from "./components/NullView.js";
import AnimationView from "./components/AnimationView.js";
import HistoryProfit from "./components/product/HistoryProfit"; /*智投历史收益查询*/
import ChooseTime from "./components/product/ChooseTime"; /*自选周期*/
import { setPayLoading } from "./action/riskInPayAction";
import InviteRegister from "./components/login/InviteRegister";
//个人资产文件夹
import InvestmentPlan from "./components/myAssets/investPlan/InvestmentPlan.js";
import InvestmentDetail from "./components/myAssets/investPlan/InvestmentDetail.js";
import InvestmentFund from "./components/myAssets/investPlan/InvestmentFund.js";
import InvestmentRecord from "./components/myAssets/investPlan/InvestmentRecord.js";
import SerchInvestment from "./components/myAssets/investPlan/SerchInvestment.js";
import TransactionRecordProduct from "./components/myAssets/queryServices/TransactionRecordProduct"; /*产品交易记录*/
import Payment from "./components/myAssets/payment/Payment.js";
import RechargeHqt from "./components/myAssets/payment/RechargeHqt.js";
import SubscriptionDetail from "./components/SubscriptionDetail";
import SubscriptionDetailTwo from "./components/SubscriptionDetailTwo";
import ReservationsManager from "./components/ReservationsManager";
import Answer from "./components/Answer";
import AnswePage from "./components/AnswerPage";
import AnswerActivityPage from "./components/AnswerActivityPage";
import AnswerActivityDatillPage from "./components/AnswerActivityDatillPage";
import PrivacyAgreement from "./components/PrivacyAgreement";
import { ConsultationDetails } from "./components/product/ConsultationDetails.js";

import SuperFundSigning from "./components/SuperFundSigning";
import TransferF from "./components/TransferF";
import SuperRate from "./components/fundDetail/SuperRate";
import ChooseGh from "./components/fundDetail/ChooseGh";

import ModalProtocol from "./components/Modal/ModalProtocol";

import Understand from "./components/Understand";
import iframeWeb from "./components/iframeWeb";

//智投重构交易记录
import Transactionrecordztgz from "./components/fundDetail/Transactionrecordztgz";
import Fuwufei from './components/fundDetail/Fuwuqimingxi'
import Feiyongxiangqing from './components/fundDetail/Feiyongxiangqing'
import Transferrecord from './components/fundDetail/Transferrecord'
import Transferinrecord from './components/fundDetail/Transferinrecord'
import Dividendreinvestedincash from './components/fundDetail/Dividendreinvestedincash'
import Servicechargerecord from './components/fundDetail/Servicechargerecord'
import Detailsofwarehouseadjustment from './components/fundDetail/Detailsofwarehouseadjustment'






import CurrentDemand from "./components/myAssets/myCard/CurrentDemand";
import AddCertificationCard from "./components/recommend/AddCertificationCard.js";
import ModifyTaxInfo from "./components/fundDetail/ModifyTaxInfo";
import HqtAddCard from "./components/myAssets/myCard/HqtAddCard";
import HqtBindCard from "./components/myAssets/myCard/HqtBindCard";
import HqtCheckCard from "./components/myAssets/myCard/HqtCheckCard";
import HqtSuccess from "./components/myAssets/myCard/HqtSuccess";

import TargetFundsList from "./components/TargetFundsList";
//止盈组合详情
import TargetProfitDetail from "./components/fundDetail/TargetProfitDetail";
import TargetProfitHaveCast from "./components/fundDetail/TargetProfitHaveCast";
import HistoryPerformance from "./components/fundDetail/HistoryPerformance";

import SuperFundDetail from "./components/fundDetail/SuperFundDetail";
import PortfolioPerformance from "./components/fundDetail/PortfolioPerformance";
import BaoGao from "./components/fundDetail/BaoGao";
import JaoYi from "./components/fundDetail/JaoYi";
import FeiL from "./components/fundDetail/FeiL";

import PositionDetails from "./components/fundDetail/PositionDetails";
import ChangeFundList from "./components/fundDetail/ChangeFundList";
import ChangeFundDetail from "./components/fundDetail/ChangeFundDetail";
import ServiceReport from './components/fundDetail/ServiceReport'
import ServiceReportDetail from './components/fundDetail/ServiceReportDetail'
import PositionDetailsHavaCast from "./components/fundDetail/PositionDetailsHaveCast";
//公募详情
import PublicOffering from './components/product/Details/PublicOffering.js';
import SuperFundDetailHaveCast from "./components/fundDetail/SuperFundDetailHaveCast";
//规划答题
import MakePlanDetail from './components/fundDetail/MakePlanDetail';
//规划结果页
import MakePlanResult from './components/fundDetail/MakePlanResult';
//新公募详情
import NewPublicOffering from './components/product/Details/NewPublicOffering.js';
import imgPage from './components/guidePage/imgPage.js';
import { GuidePage, GuidePageRef } from './components/guidePage'

window.historyData = [];
const uMeng = (nextState, action) => {
  let enterType = Util.return_enterType;
  let title = "";
  try {
    switch (nextState.location.pathname) {
      case "/PaymentSuperFund":
        title = "超级基金（在线支付）";
        break;
      case "/RedeemSuperFund":
        title = "超级基金赎回";
        break;
      case "/LoginHxjj":
        title = "华夏基金账号登录";
        break;
      case "/RedeemBankList":
        title = "选择赎回渠道";
        break;
      case "/WebView":
        title = nextState.location.state.name;
        break;
      case "/AddCard":
        title = "添加银行卡输入银行卡号页面";
        break;
      case "/AddPhone":
        title = "添加银行卡输入手机号页面";
        break;
      case "/Verification":
        title = "添加银行卡短信验证码页";
        break;
      case "/PayCardList":
        title = "选择支付方式";
        break;
      case "/Success":
        title = nextState.location.state.title;
        break;
      case "/ErrorResult":
        title = nextState.location.state.title;
        break;
      case "/QuestionnaireList":
        title = "问卷题目列表页";
        break;
      case "/FinishQuestionnaireSuccess":
        title = "问卷成功页面";
        break;
      case "/Transfer":
        title = "调仓页面";
        break;
      case "/TaxInfo":
        title = "税收页面";
        break;
      case "/HighestRiskPoint":
        title = "特高风险页";
        break;
      case "/FixedInvestmentSuperFund":
        title = "超级基金(定投)";
        break;
    }
    window._czc.push(["_trackEvent", enterType, title, action]);
  } catch (e) {}
};
const outFun = (nextState, replaceState) => {
  uMeng(nextState, "离开");
  console.log(nextState);
  if (window.historyData.indexOf(window.location.hash) >= 0) {
    window.historyData.splice(window.historyData.indexOf(window.location.hash));
    sessionStorage.setItem("app_index", window.historyData); //没存储过 存储APP首页的位置
  }
  store.dispatch(setPayLoading(false));
  Loading.hide();
};
const enterFun = (nextState, replaceState) => {
  if ((nextState.location.pathname == "PaymentAllSuperFund" || nextState.location.pathname == "/PaymentAllSuperFund") && nextState.location.action == "PUSH") {
    const sess = sessionStorage.getItem("modalShowByTip");
    if (sess) {
      let arr = sess.split(",");
      if (arr.indexOf("zxzf_zt") != -1) {
        arr.splice(arr.indexOf("zxzf_zt"), 1);
        sessionStorage.setItem("modalShowByTip", arr.join());
      }
    }
    sessionStorage.setItem("activeByPaymentAllSuperFund", "");
  }
  if ((nextState.location.pathname == "TransferF" || nextState.location.pathname == "/TransferF") && nextState.location.action == "PUSH") {
    const sess = sessionStorage.getItem("modalShowByTip");
    if (sess) {
      let arr = sess.split(",");
      if (arr.indexOf("zh_zt") != -1) {
        arr.splice(arr.indexOf("zh_zt"), 1);
        sessionStorage.setItem("modalShowByTip", arr.join());
      }
    }
  }
  if (nextState.location.pathname == "/") {
    sessionStorage.setItem("home_url", window.location.hash);
  }
  let ua = navigator.userAgent.toLowerCase();
  uMeng(nextState, "进入");
  window.scrollTo(1, 0);
  if (ua.indexOf("amcfmapp") == -1) {
    //判断是否不是App进入
    if (sessionStorage.getItem("app_index") == null) {
      //判断是否是第一次进入页面，没存储代表第一次进入
      window.clearLocalStorage(); //清楚缓存
      if (window.location.hash != "#/" && window.location.hash.indexOf("enterType") == -1 && window.location.hash.indexOf("venderType") == -1) {
        //回到首页
        window.historyData = ["#/"]; //路由初始化
        hashHistory.replace({
          pathname: "/",
        });
      } else {
        window.historyData.push(window.location.hash);
      }
      sessionStorage.setItem("app_index", window.historyData);
    } else {
      var old = sessionStorage.getItem("app_index").split(",");
      if (old[old.length - 1] == window.location.hash) {
        //刷新浏览器判断 同一个url代表刷新
        window.historyData = old; //存入缓存
      } else {
        if (window.historyData.indexOf(window.location.hash) < 0) {
          window.historyData.push(window.location.hash);
          sessionStorage.setItem("app_index", window.historyData);
        }
      }
    }
  }
};
class App extends Component {
  componentWillMount() {
    let ua = navigator.userAgent.toLowerCase();
    if (!localStorage.boardFlag && ua.indexOf("amcfmapp") > -1) {
      let div = document.createElement("div");
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const establishmentYears = currentYear - 1998;//1998华夏基金成立时间
      div.className = "board";
      document.body.appendChild(div);
      ReactDOM.render(
        <div>
          <img src={require("./img/slices1@2x.png")} />
          <img src={require("./img/slices2@2x.png")} />
          <img src={require("./img/slices3@2x.png")} />
          <img src={require("./img/slices4@2x.png")} />
          <img src={require("./img/slices5@2x.png")} />
          <div
            onClick={() => {
              this.close();
            }}
            style={{ top: (window.screen.width / 750) * 846 + "px" }}
            className="btn1"
          >
            立即体验
          </div>
          <div className="textCont" style={{ top: (window.screen.width / 750) * 946 + "px" }}>
            <text>华夏基金{establishmentYears}年资产管理经验</text>
            <text>基于MVP模型的智能投资组合</text>
            <text>针对不同阶段的财富目标</text>
            <text>提供一键式智能化资产配置整体解决方案</text>
          </div>
          <div
            onClick={() => {
              this.close();
            }}
            style={{ bottom: (window.screen.width / 750) * 60 + "px" }}
            className="btn2"
          >
            立即体验
          </div>
        </div>,
        div
      );
    }
  }
  close() {
    localStorage.setItem("boardFlag", true);
    document.getElementsByClassName("board")[0].remove();
  }
  render() {
    let ua = navigator.userAgent.toLowerCase();
    var style = document.createElement("style");
    style.type = "text/css";
    if (ua.indexOf("amcfmapp") > -1) {
      style.innerHTML = ".header-red{background:#CC3040;height:68px;padding-top:22px}#superContent{padding-top: 68px}.header-red2{background:#f03456}.boxContent{width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
    } else if (ua.indexOf("hxcfH5WX") != -1 || ua.match(/MicroMessenger/i) == "micromessenger") {
      style.innerHTML = ".boxContent{width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
    } else {
      style.innerHTML = ".content{padding-top: 44px;min-height:" + window.winHeight + "px}.boxContent{padding-top:44px;width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
    }
    document.getElementsByTagName("HEAD").item(0).appendChild(style);
    return (
      <div>
        <Provider store={store}>
          <Router history={hashHistory}>
            <Route onLeave={outFun} onEnter={enterFun} exact path="/" component={Investment} />
            <Route onLeave={outFun} onEnter={enterFun} path="/animationView" component={AnimationView} />
            <Route onLeave={outFun} onEnter={enterFun} path="/NewPublicOffering" component={NewPublicOffering} />
            <Route onLeave={outFun} onEnter={enterFun} path="/nullView" component={NullView} />
            <Route onLeave={outFun} onEnter={enterFun} path="/FinishQuestionnaireSuccess" component={FinishQuestionnaireSuccess} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HighestRiskPoint" component={HighestRiskPoint} />
            <Route onLeave={outFun} onEnter={enterFun} path="/recommend" component={Recommend} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Transfer" component={Transfer} />
            <Route onLeave={outFun} onEnter={enterFun} path="/BindingMobile" component={BindingMobile} />
            <Route onLeave={outFun} onEnter={enterFun} path="/RedeemBankList" component={RedeemBankList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AddCard" component={AddCard} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AddPhone" component={AddPhone} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Verification" component={Verification} />
            <Route onLeave={outFun} onEnter={enterFun} path="/knowMore" component={KnowMore} />
            <Route onLeave={outFun} onEnter={enterFun} path="/encyclopedia" component={Encyclopedia} />
            <Route onLeave={outFun} onEnter={enterFun} path="/encyclopediaDetail" component={EncyclopediaDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/recoQuestionDoing" component={RecoQuestionDoing} />
            <Route onLeave={outFun} onEnter={enterFun} path="/recoQuestionFinish" component={RecoQuestionFinish} />
            <Route onLeave={outFun} onEnter={enterFun} path="/pensionCalculator" component={PensionCalculator} />
            <Route onLeave={outFun} onEnter={enterFun} path="/pensionCalculatorResult" component={PensionCalculatorResult} />
            <Route onLeave={outFun} onEnter={enterFun} path="/pensionCalculatorPlan" component={PensionCalculatorPlan} />
            <Route onLeave={outFun} onEnter={enterFun} path="/educationCalculatorSelectSchool" component={EducationCalculatorSelectSchool} />
            <Route onLeave={outFun} onEnter={enterFun} path="/educationCalculator" component={EducationCalculator} />
            <Route onLeave={outFun} onEnter={enterFun} path="/educationCalculatorResult" component={EducationCalculatorResult} />
            <Route onLeave={outFun} onEnter={enterFun} path="/educationCalculatorPlan" component={EducationCalculatorPlan} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/certificationCard" component={CertificationCard} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/ChangTime" component={ChangTime} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/CertificationUpload" component={CertificationUpload} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/CertiUpload" component={CertiUpload} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/certificationCardAgain" component={CertificationCardAgain} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/certificationSetPhone" component={CertificationSetPhone} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/certificationCheckPhone" component={CertificationCheckPhone} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/certificationSetPassWord" component={CertificationSetPassWord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/PaymentSuperFund" component={PaymentSuperFund} />
            <Route onLeave={outFun} onEnter={enterFun} path="/PaymentAllSuperFund" component={PaymentAllSuperFund} />
            <Route onLeave={outFun} onEnter={enterFun} path="/FixedInvestmentSuperFund" component={FixedInvestmentSuperFund} />
            <Route onLeave={outFun} onEnter={enterFun} path="/FixedInvestmentSuperFundChange" component={FixedInvestmentSuperFundChange} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Payment" component={Payment} />
            <Route onLeave={outFun} onEnter={enterFun} path="/RechargeHqt" component={RechargeHqt} />
            <Route onLeave={outFun} onEnter={enterFun} path="/RedeemCurrencyList" component={RedeemCurrencyList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/RedeemSuperFund" component={RedeemSuperFund} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Success" component={Success} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ErrorResult" component={ErrorResult} />
            <Route onLeave={outFun} onEnter={enterFun} path="/WebView" component={WebView} />
            <Route onLeave={outFun} onEnter={enterFun} path="/PayCardList" component={PayCardList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HqtCardList" component={HqtCardList} />

            <Route onLeave={outFun} onEnter={enterFun} path="/SuperFundDetail" component={SuperFundDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/SuperFundList" component={SuperFundList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransactionRecord" component={TransactionRecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/OperationRecord" component={OperationRecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Configuration" component={Configuration} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TaxInfo" component={TaxInfo} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransactionDetail" component={TransactionDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/LoginHxjj" component={Login} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/Loginkah" component={Loginkah} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Login" component={LoginHxcf} />
            <Route onLeave={outFun} onEnter={enterFun} path="/userBindingMobile" component={UserBindingMobile} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HxjjBindingMobile" component={HxjjBindingMobile} />
            <Route onLeave={outFun} onEnter={enterFun} path="/register" component={Register} />
            <Route onLeave={outFun} onEnter={enterFun} path="/forgetPassword" component={ForgetPassword} />
            <Route onLeave={outFun} onEnter={enterFun} path="/verifyDynamicCode" component={VerifyDynamicCode} />
            <Route onLeave={outFun} onEnter={enterFun} path="/verifyDynamicCodeSec" component={VerifyDynamicCodeSec} />
            <Route onLeave={outFun} onEnter={enterFun} path="/setNewPassword" component={SetNewPassword} />
            <Route onLeave={outFun} onEnter={enterFun} path="/QuestionnaireList" component={QuestionnaireList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransitRecords" component={TransitRecords} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransitHistory" component={TransitHistory} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransitHistoryDetial" component={TransitHistoryDetial} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TaxSuccess" component={TaxSuccess} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HistoryProfit" component={HistoryProfit} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ChooseTime" component={ChooseTime} />
            <Route onLeave={outFun} onEnter={enterFun} path="/InviteRegister" component={InviteRegister} />
            <Route onLeave={outFun} onEnter={enterFun} path="/InvestmentFund" component={InvestmentFund} />
            <Route onLeave={outFun} onEnter={enterFun} path="/InvestmentRecord" component={InvestmentRecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/InvestmentPlan" component={InvestmentPlan} />
            <Route onLeave={outFun} onEnter={enterFun} path="/InvestmentDetail" component={InvestmentDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/SerchInvestment" component={SerchInvestment} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransactionRecordProduct" component={TransactionRecordProduct} />
            <Route onLeave={outFun} onEnter={enterFun} path="/SubscriptionDetail" component={SubscriptionDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/SubscriptionDetailTwo" component={SubscriptionDetailTwo} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ReservationsManager" component={ReservationsManager} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Answer" component={Answer} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AnswePage" component={AnswePage} />
            <Router onLeave={outFun} onEnter={enterFun} path="/PrivacyAgreement" component={PrivacyAgreement} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ConsultationDetails" component={ConsultationDetails} />

            <Route onLeave={outFun} onEnter={enterFun} path="/SuperFundSigning" component={SuperFundSigning} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TransferF" component={TransferF} />
            <Route onLeave={outFun} onEnter={enterFun} path="/SuperRate" component={SuperRate} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ChooseGh" component={ChooseGh} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ModalProtocol" component={ModalProtocol} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Understand" component={Understand} />
            <Route onLeave={outFun} onEnter={enterFun} path="/iframeWeb" component={iframeWeb} />

            <Route onLeave={outFun} onEnter={enterFun} path="/CurrentDemand" component={CurrentDemand} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AddCertificationCard" component={AddCertificationCard} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ModifyTaxInfo" component={ModifyTaxInfo} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HqtAddCard" component={HqtAddCard} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HqtBindCard" component={HqtBindCard} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HqtCheckCard" component={HqtCheckCard} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HqtSuccess" component={HqtSuccess} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AnswerActivityDatillPage" component={AnswerActivityDatillPage} />
            <Route onLeave={outFun} onEnter={enterFun} path="/AnswerActivityPage" component={AnswerActivityPage} />

            <Route onLeave={outFun} onEnter={enterFun} path="/TargetFundsList" component={TargetFundsList} />

            <Route onLeave={outFun} onEnter={enterFun} path="/TargetProfitDetail" component={TargetProfitDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/TargetProfitHaveCast" component={TargetProfitHaveCast} />
            <Route onLeave={outFun} onEnter={enterFun} path="/HistoryPerformance" component={HistoryPerformance} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/MakePlanDetail" component={MakePlanDetail} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/MakePlanResult" component={MakePlanResult} />
            <Route onLeave={outFun} onEnter={enterFun} path="/PortfolioPerformance" component={PortfolioPerformance} />

            <Route onLeave={outFun} onEnter={enterFun} path="/BaoGao" component={BaoGao} />
            <Route onLeave={outFun} onEnter={enterFun} path="/JaoYi" component={JaoYi} />
            <Route onLeave={outFun} onEnter={enterFun} path="/FeiL" component={FeiL} />

            <Route onLeave={outFun} onEnter={enterFun} path="/PositionDetails" component={PositionDetails} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ChangeFundList" component={ChangeFundList} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ChangeFundDetail" component={ChangeFundDetail} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ServiceReport" component={ServiceReport} />
            <Route onLeave={outFun} onEnter={enterFun} path="/ServiceReportDetail" component={ServiceReportDetail} />
            <Route onLeave={outFun}  onEnter={enterFun} path="/PublicOffering" component={PublicOffering} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Transactionrecordztgz" component={Transactionrecordztgz} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Fuwufei" component={Fuwufei} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Feiyongxiangqing" component={Feiyongxiangqing} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Transferrecord" component={Transferrecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Transferinrecord" component={Transferinrecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Dividendreinvestedincash" component={Dividendreinvestedincash} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Servicechargerecord" component={Servicechargerecord} />
            <Route onLeave={outFun} onEnter={enterFun} path="/Detailsofwarehouseadjustment" component={Detailsofwarehouseadjustment} />
            <Route onLeave={outFun} onEnter={enterFun} path="/PositionDetailsHavaCast" component={PositionDetailsHavaCast} />
            <Route onLeave={outFun} onEnter={enterFun} path="/imgPage" component={imgPage} />
            
            
            
            <Route onLeave={outFun}  onEnter={enterFun} path="/SuperFundDetailHaveCast" component={SuperFundDetailHaveCast} />
          </Router>
        </Provider>
        <GuidePage ref={ref =>  GuidePageRef.current = ref } />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/AppGJ.js